<template>
    <div>
        <CList @FiltrarC="Lista" :pConfigList="ConfigList" :pFiltro="Filtro" :segurity="segurity">
            <template slot="Filtros">
                <div class="col-auto">
                    <label for="">Filtro: </label>
                </div>
                <div class="col-auto">
                    <select @change="Lista" name="" id="" class="form-control form-select" v-model="Filtro.TipoFiltro">
                        <option value="FechaEnvio">Fecha de Envío</option>
                        <option value="FechaEntrega">Fecha Probable de Entrega</option>
                    </select>
                </div>
                <div class="col-auto">
                    <Datepicker @input="Lista" v-model="Filtro.FechaInicio" :input-class="Setpicker.Style" :format="Setpicker.Formato" :language="Setpicker.Idioma" placeholder="0000-00-00"></Datepicker>
                </div>
                <div class="col-auto">
                    <Datepicker @input="Lista" v-model="Filtro.FechaFin" :input-class="Setpicker.Style" :format="Setpicker.Formato" :language="Setpicker.Idioma" placeholder="0000-00-00"></Datepicker>
                </div>
            </template>
            <template slot="header">
                <th :class="StyleTh+' text-center'">#</th>
                <th :class="StyleTh">Número de Paquete</th>
                <th :class="StyleTh">Fecha de Envío</th>
                <th :class="StyleTh">Cliente</th>
                <th :class="StyleTh">Paquetería</th>
                <th :class="StyleTh">Número de Guía</th>
                <th :class="StyleTh">Fecha Probable de Entrega</th>
                <th :class="StyleTh+' text-center'">Acciones</th>
            </template>
            <template slot="body">
                <tr v-for="(lista,index) in ListaArrayRows" :key="index">
                    <td class="text-center"><p :class="StyleTd">{{ index+1 }}</p></td>
                    <td><h6 :class="StylePr">{{ lista.NumPaquete }}</h6></td>
                    <td><p :class="StyleTd">{{ lista.FechaEnvio }}</p></td>
                    <td><p :class="StyleTd">{{ lista.Nombre }}</p></td>
                    <td><p :class="StyleTd">{{ lista.PaqNombre }}</p></td>
                    <td><p :class="StyleTd">{{ lista.Numero }}</p></td>
                    <td><p :class="StyleTd">{{ lista.FechaEntrega }}</p></td>
                    <td class="align-middle text-end">
                        <CBtnAccion :pShowBtnEdit="true" :pBtnShowButtonDelete="true" :pIsModal="false" :pId="lista.IdEnvio" :pEmitSeccion="ConfigList.EmitSeccion" :pGoRoute="ConfigList.GoRoute" :segurity="segurity">

                        </CBtnAccion>
                    </td>
                </tr>
                <CSinRegistros :pContIf="ListaArrayRows.length" :pColspan="8"></CSinRegistros>
            </template>
        </CList>
    </div>
</template>
<script>
import Configs from '@/helpers/VarConfig.js';
import Calendar from '@/helpers/StaticComboBox.js';
const EmitEjecuta = 'seccionEnvio';
export default{
    name:'ListaEnvio',
    props:['sFiltros'],
    components:{

    },
    data(){
        return{
            ConfigList:{
                Title: 'Paquetes',
                IsModal: false,
                /*ShowYear: true,*/
                ShowLoader: true,
                EmitSeccion: EmitEjecuta,
                BtnReturnShow: false,
                ShowTitleFirst:false,
                TitleFirst: '',
                GoRoute:'FormEnvio'
            },
            Filtro:{
                Nombre: '',
                Pagina: 1,
                Entrada: 25,
                TotalItem: 0,
                Placeholder: '# Paquete,Cliente,# Guia',
                FechaInicio:'',
                FechaFin:'',
                TipoFiltro:'FechaEnvio'
                /*Anio: moment(new Date()).format('YYYY'),*/
            },
            segurity: {},
            obj: {},
            ListaArrayRows: [],               
            StyleTh: Configs.stylesTable.StyleTh,
            StylePr: Configs.stylesTable.StylePr,
            StyleTd: Configs.stylesTable.StyleTd,
            Setpicker:Calendar.calendarSettings
        }
    },
    methods:{
        async Lista(){
            this.ConfigList.ShowLoader=true;
            await this.$http.get("envio",{
                params:{
                    TxtBusqueda:this.Filtro.Nombre,
                    Entrada:this.Filtro.Entrada,
                    Pagina:this.Filtro.Pagina,
                    FechaInicio:this.Filtro.FechaInicio,
                    FechaFin:this.Filtro.FechaFin,
                    TipoFiltro:this.Filtro.TipoFiltro
                }
            }).then((res)=>{
                this.Filtro.Pagina=res.data.data.current_page;
                this.Filtro.TotalItem=res.data.data.total;
                this.ListaArrayRows=res.data.data.data;
                // this.segurity=res.data.segurity;
            }).finally(()=>{
                this.ConfigList.ShowLoader=false;
            });
        },
        Eliminar(Id){
            this.$swal(Configs.configEliminar).then((result) =>
            {
                if(result.value)
                {
                    this.$http.delete('envio/'+Id
                    ).then((res) => {
                        this.$swal(Configs.configEliminarConfirm);
                        this.Lista();
                    }).catch(err => {
                        this.$toast.error(err.response.data.message);
                    });
                } 
            });
        }
    },
    created(){
        this.bus.$off('Delete_'+EmitEjecuta);
        this.bus.$off('List_'+EmitEjecuta);
    },
    mounted(){
        this.Filtro.FechaInicio=new Date();
        this.Filtro.FechaFin=new Date();
        this.Lista();
        this.bus.$on('Delete_'+EmitEjecuta,(Id)=>{
            this.Eliminar(Id);
        });
        this.bus.$on('List_'+EmitEjecuta,()=>{
            this.Lista();
        });
    }
}
</script>